package devxertech.com.pages.services.UxPage

import androidx.compose.runtime.Composable
import devxertech.com.seo.ServiceJsonLd
import devxertech.com.seo.PageMetadata
import devxertech.com.seo.PageSeo
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.component.FieldTitleTextNormalSimple
import devxertech.com.pages.commons.CommonAboutSection
import devxertech.com.pages.commons.CommonArrow
import devxertech.com.pages.commons.CommonHeader
import devxertech.com.pages.commons.MakeYourOwnTeam
import devxertech.com.pages.commons.TeamService
import devxertech.com.pages.commons.WebDesignBoxes
import devxertech.com.pages.commons.toolUseHeading
import devxertech.com.pages.dashboard.footerSection.HomepageFooter
import devxertech.com.pages.dashboard.ratingSection.RatingSection
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import devxertech.com.utils.Res
import devxertech.com.utils.Res.Image.uiAbout
import kotlinx.browser.window
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Page("/ui-services")
@Composable
fun UiUxServicesPage() {
    PageMetadata(PageSeo.Design)
    ServiceJsonLd("/ui-services", PageSeo.Design, "UI/UX Design")
    val sitePalette = ColorMode.current.toSitePalette()
    val breakpoint = rememberBreakpoint()


    Column(
        modifier = Modifier.fillMaxSize().backgroundColor(sitePalette.bodyBackgroundSecondary.rgb)
    ) {
//
        CommonHeader(
            imageAlt = "User interface and user experience design illustration",
            mainHeadingAsH1 = true,
            image = Res.Image.ui_Header,
            breakpoint = breakpoint,
            headingText = "UI/UX Design Services",
            descriptionText = "Interactive, creative and state-of-the-art UI/UX design services"
        )
//
        CommonArrow("UI/UX Design")
//
//        UiUxAboutSection(breakpoint, sitePalette)
        CommonAboutSection(
            breakpoint = breakpoint,
            title = "What’s Makes",
            firstFont = "Devxer",
            firstFontColor = sitePalette.primary.rgb,
            secondFont = "UI/UX Design to Stand Out?",
            secondFontColor = sitePalette.commonSecondaryButtonColor.rgb,
            description = "We are perfect at blending concepts-We love to hear our" +
                    " clients’ ideas and blend it effectively and creatively with our team’s skillful design suggestions and outputs." +
                    "We conduct in-depth research- Any project will lack authenticity and risk management guards " +
                    "if there is no prior research supporting it & our expert team at DEvxer loves to delve " +
                    "in detailed research before producing final results. Top Notch Deliverables- Our final" +
                    " product is a pillar of industry-led trends and practices while showcasing " +
                    "a complete essence of the product’s message and design.",
            imageName = uiAbout
        )
//
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .padding(top = if (breakpoint > Breakpoint.MD) 60.px else if (window.screen.width > 1600) 35.px else 20.px,
                    bottom = if (breakpoint < Breakpoint.MD) 0.px else 30.px),
            contentAlignment = Alignment.Center
        ) {
            Column(
                verticalArrangement = Arrangement.Center,
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                FieldTitleTextNormalSimple(
                    "UI/UX SERVICES",
                    asH2 = true,
                    color = sitePalette.commonSecondaryButtonColor.rgb,
                    fontSize = 18.px,
                    textAlign = TextAlign.Center,
                )
                Row(
                    modifier = Modifier.flexWrap(FlexWrap.Wrap),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.Center
                ) {
                        FieldTitleTextNormalSimple(
                            "WHAT WE ",
                            color = sitePalette.commonSecondaryButtonColor.rgb,
                            fontFamily = Constants.ROBOTO_FONT,
                            fontSize = if (breakpoint > Breakpoint.MD) 35.px else 20.px,
                            fontWeight = 700,
                        )
                        FieldTitleTextNormalSimple(
                            "OFFER?",
                            color = sitePalette.primary.rgb,
                            fontFamily = Constants.ROBOTO_FONT,
                            fontSize = if (breakpoint > Breakpoint.MD) 35.px else 20.px,
                            fontWeight = 700,

                        )
                }
                Row(
                    modifier = Modifier.fillMaxWidth()
                        .padding(bottom = if (breakpoint < Breakpoint.MD) 10.px else if (window.screen.width > 1600) 0.px else 80.px).flexWrap(FlexWrap.Wrap),
                    horizontalArrangement = Arrangement.Center
                ) {
                    TeamService(
                        image = Res.Image.mbilUi,
                        title = "Mobile App UI/UX Design",
                        description = "Our mobile app UI/UX design services aim to provide an enjoyable, " +
                                "effective and an interactive experience between the user and the " +
                                " app to ensure the app’s long-term success and sustainability.",
                        )
                    TeamService(
                        image = Res.Image.webUi,
                        title = "Web App UI/UX Design",
                        description = "We combine innovative design, responsive layouts, and " +
                                "seamless interactions to ensure your site meets both business" +
                                " goals and user needs. Our expert team works closely with " +
                                "you to deliver visually stunning and functional web designs.",
                    )
                    TeamService(
                        image = Res.Image.brandUi,
                        title = "UI/UX Brand Identity",
                        description = "UI/UX brand identity is always under consideration whenever " +
                                "our team works on creating an exciting user interface design," +
                                " to ensure an easy path to the product branding and promotion.",
                    )
                }

            }
        }
//
        Column(
            modifier = Modifier.fillMaxWidth().margin(top = if (breakpoint > Breakpoint.MD) 20.px else 0.px)
                .padding(top = 30.px, bottom = 50.px),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            FieldTitleTextNormalSimple(
                "OUR UI AND UX DESIGN PROCESSES",
                color = sitePalette.commonSecondaryButtonColor.rgb,
                fontSize = 18.px,
                textAlign = TextAlign.Center,
            )
            Row(modifier = Modifier.flexWrap(FlexWrap.Wrap),
                horizontalArrangement = Arrangement.Center,
                verticalAlignment = Alignment.CenterVertically
            ) {
                FieldTitleTextNormalSimple(
                    "DIFFERENT YET",
                    color = sitePalette.primary.rgb,
                    fontFamily = Constants.ROBOTO_FONT,
                    fontSize = if (breakpoint == Breakpoint.LG) 30.px else if (breakpoint < Breakpoint.LG) 22.px else 35.px,
                    fontWeight = 700,

                )
                FieldTitleTextNormalSimple(
                    " IN Perfect Harmony",
                    color = sitePalette.commonSecondaryButtonColor.rgb,
                    fontFamily = Constants.ROBOTO_FONT,
                    fontSize = if (breakpoint == Breakpoint.LG) 30.px else if (breakpoint < Breakpoint.LG) 22.px else 35.px,
                    fontWeight = 700,
                    textTransform = TextTransform.Uppercase
                )
                Box(modifier = Modifier.fillMaxWidth().margin(top = 30.px), contentAlignment = Alignment.Center) {
                    Image(src = Res.Image.uiDesignSvg, description = "User interface design process diagram", modifier = Modifier.margin(topBottom = 20.px)
                        .fillMaxWidth(if(window.screen.width > 475) 63.percent else 90.percent))
                }
            }

        }
//
        MakeYourOwnTeam(breakpoint)
//
        Column(modifier = Modifier.fillMaxWidth().padding(top = if (breakpoint < Breakpoint.MD) 10.px else 60.px,
            bottom = if (breakpoint < Breakpoint.MD) 10.px else 60.px),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            toolUseHeading(breakpoint)
            Row(modifier = Modifier.flexWrap(FlexWrap.Wrap),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.Center
            ) {
                FieldTitleTextNormalSimple(
                    "OUR FAVOURITE IN",
                    color = sitePalette.commonSecondaryButtonColor.rgb,
                    fontSize = if (breakpoint > Breakpoint.MD) 35.px else 20.px,
                    fontWeight = 700,
                    marginBottom =  if (breakpoint < Breakpoint.MD) 5.px else 20.px,
                    )
                FieldTitleTextNormalSimple(
                    " UI/UX",
                    color = sitePalette.primary.rgb,
                    fontSize = if (breakpoint > Breakpoint.MD) 35.px else 20.px,
                    fontWeight = 700,
                    marginBottom =  if (breakpoint < Breakpoint.MD) 5.px else 20.px,
                )
            }

        Column(modifier = Modifier,
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Row(modifier = Modifier.fillMaxWidth(when {breakpoint > Breakpoint.LG -> 1200.px
                breakpoint == Breakpoint.LG -> 100.percent
                breakpoint >= Breakpoint.MD -> 85.percent
                else -> 100.percent })
                .padding(top = 30.px, bottom = if (breakpoint == Breakpoint.MD) 20.px else 30.px)
                .gap(when {breakpoint < Breakpoint.MD -> 5.px
                    breakpoint == Breakpoint.MD -> 25.px
                    breakpoint == Breakpoint.LG -> 10.px
                    else -> 33.px })
                .flexWrap(FlexWrap.Wrap),
                horizontalArrangement = if (breakpoint < Breakpoint.MD) Arrangement.SpaceAround else Arrangement.Start,
                verticalAlignment = Alignment.CenterVertically
            ) {
                WebDesignBoxes(Res.Image.xdLogo, "AdobeXD", 44.px, 43.px)
                WebDesignBoxes(Res.Image.psLogo, "Photoshop", 39.px, 38.px, 0.px, 10.px, 0.5.px, 0.px)
                WebDesignBoxes(Res.Image.aiLogo, " Adobe illustrator", 50.px, 49.px, 0.px, 0.px, 5.px, 0.px)
                WebDesignBoxes(Res.Image.figmaLogo, "figma", 42.px, 43.px, 0.px, 0.px, 5.px, 0.px)
                WebDesignBoxes(Res.Image.aeLogo, "Adobe AfterEffect", 46.px, 46.px, 0.px, 0.px, 5.px, 0.px)
                WebDesignBoxes(Res.Image.sketchLogo, "sketch", 48.px, 43.px)
            }
        }
    }
//
        RatingSection(breakpoint)
        HomepageFooter(breakpoint)
    }
}
